import { useMemo, useState } from 'react'
import GlassOverlay from './GlassOverlay'
import CloseGlyph from './CloseGlyph'
import { formatEuroFr } from '../utils/editProductOutcome'
import { filterCartsForPicker, shouldShowCompareSearch } from '../utils/compareCartsPolicy'
import '../styles/scrollbar.css'
import './CompareCartPicker.css'

export default function CompareCartPicker({
  isOpen,
  onClose,
  sourceCart,
  carts = [],
  onSelect,
  returnFocusRef,
}) {
  const [query, setQuery] = useState('')
  const options = useMemo(
    () => filterCartsForPicker(carts, sourceCart?.id, query),
    [carts, query, sourceCart?.id],
  )
  const showSearch = shouldShowCompareSearch(
    filterCartsForPicker(carts, sourceCart?.id).length,
  )

  return (
    <GlassOverlay
      isOpen={isOpen}
      onClose={onClose}
      labelledBy="compare-picker-title"
      returnFocusRef={returnFocusRef}
      panelClassName="compare-picker-panel"
      followPointer={false}
    >
      <div className="compare-picker">
        <header className="compare-picker-header">
          <div>
            <p className="compare-picker-kicker">Panier de départ</p>
            <h2 id="compare-picker-title">{sourceCart?.name || 'Comparer'}</h2>
            <p className="compare-picker-meta">
              {formatEuroFr(sourceCart?.total)} · {sourceCart?.items_count || 0} article(s)
            </p>
          </div>
          <button
            type="button"
            className="compare-picker-close"
            onClick={onClose}
            aria-label="Fermer la sélection"
          >
            <CloseGlyph />
          </button>
        </header>
        {showSearch ? (
          <input
            className="compare-picker-search"
            type="search"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder="Rechercher un panier"
            aria-label="Rechercher un panier"
          />
        ) : null}
        <div className="compare-picker-list lg-scroll" role="listbox" aria-label="Paniers à comparer">
          {options.length === 0 ? (
            <p className="compare-picker-empty">Aucun autre panier à comparer.</p>
          ) : (
            options.map((cart) => (
              <button
                key={cart.id}
                type="button"
                className="compare-picker-item"
                role="option"
                onClick={() => {
                  onSelect?.(cart)
                  onClose?.()
                }}
              >
                <span className="compare-picker-name">{cart.name}</span>
                <span className="compare-picker-stats">
                  {formatEuroFr(cart.total)} · {cart.items_count || 0} article(s)
                </span>
              </button>
            ))
          )}
        </div>
      </div>
    </GlassOverlay>
  )
}
